import { useEffect, useState } from "react";

interface ToastProps {
  type: "success" | "error";
  message: string;
  onClose: () => void;
  duration?: number; // Duration in milliseconds
}

export default function Toast({ type, message, onClose, duration = 2000 }: ToastProps) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), duration - 1000);
    const removeTimer = setTimeout(onClose, duration);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [onClose, duration]);

  return (
    <div
      className={`fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2
        px-6 py-4 rounded-lg shadow-2xl text-white text-lg font-medium
        transition-opacity duration-1000 z-50
        ${fadeOut ? "opacity-0" : "opacity-100"}
        ${type === "success" ? "bg-green-600" : "bg-red-600"}`}
    >
      {message}
    </div>
  );
}
